import { IdentificationRequestStatus } from '@models/IdentificationRequests.model';
import styled, { css } from 'styled-components';

export const RequestStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 9px;
`;

export const RequestStatusBadge = styled.span`
  padding: 3px;
  border-radius: 100%;

  ${(props: { $status: IdentificationRequestStatus }) => {
    if (['information_needed', 'confirm_product'].includes(props.$status)) {
      return css`
        background: #ff9900;
      `;
    }
    if (['resolved'].includes(props.$status)) {
      return css`
        background: #52bd94;
      `;
    }
    if (['closed'].includes(props.$status)) {
      return css`
        background: #c1c4d6;
      `;
    }
    return css`
      background: #1371fe;
    `;
  }}
`;

export const RequestStatusTag = styled.p`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin: unset;
  color: #474d66;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;

  ${(props: { $status?: IdentificationRequestStatus }) =>
    props.$status === 'open' &&
    css`
      color: #1371fe;
    `}
`;
